
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.25 9a3 3 0 013-3h16a3 3 0 013 3v1a3 3 0 01-3 3h-16a3 3 0 01-3-3V9zm3-1a1 1 0 00-1 1v1a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1h-16z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.25 12a1 1 0 011-1h16a1 1 0 011 1v7a3 3 0 01-3 3h-12a3 3 0 01-3-3v-7zm2 1v6a1 1 0 001 1h12a1 1 0 001-1v-6h-14z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.25 6a1 1 0 011 1v14a1 1 0 11-2 0V7a1 1 0 011-1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.25 5.234A3.233 3.233 0 017.477 2h.902c2.69 0 4.871 2.18 4.871 4.871 0 .624-.505 1.129-1.129 1.129H7.01a2.765 2.765 0 01-2.76-2.766zM7.477 4c-.673 0-1.227.552-1.227 1.234 0 .424.344.766.76.766h4.106a2.872 2.872 0 00-2.737-2h-.902z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.25 5.234A3.233 3.233 0 0017.023 2h-.902a4.871 4.871 0 00-4.871 4.871c0 .624.505 1.129 1.129 1.129h5.111a2.765 2.765 0 002.76-2.766zM17.023 4c.673 0 1.227.552 1.227 1.234a.765.765 0 01-.76.766h-4.105c.368-1.16 1.454-2 2.736-2h.902z"}})])
          )
        }
      }
    